import SectionTitle from '../ui/section-title'

import PortfolioCardSkeleton from './portfolio-card-skeleton'

const PortfolioListSkeleton = () => {
  return (
    <section className="mb-6">
      <SectionTitle
        title="Portfolio"
        rightContent={<span className="text-sm font-semibold text-muted lg:text-base">Calculating...</span>}
      />
      <div className="mt-4 grid grid-cols-[repeat(auto-fill,minmax(350px,1fr))] gap-4">
        {[1, 2].map((i) => (
          <PortfolioCardSkeleton key={i} />
        ))}
      </div>
    </section>
  )
}

export default PortfolioListSkeleton
